module.exports = __webpack_public_path__ + "img/instagram-icon-footer.315a626f.svg";